import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translate2',
  pure: true
})
@Injectable()
export class TranslatePipe implements PipeTransform {

  constructor(private translateProvider: TranslateService) {}

  transform(value: any): any {
    return value[this.translateProvider.getDefaultLang()];
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/translate.ts